/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "761ca79bca5c8ac6aba57cf8c89e024dd677ece7";
